export default __webpack_public_path__ + "static/media/photostrip.743b38e4.jpg";